module.exports = __webpack_public_path__ + "img/password.1c801462.svg";